import { useLocation } from "react-router-dom";
import { BRAND } from "@/lib/constants";

export default function WhatsAppButton() {
  const loc = useLocation();

  // Hide button on full-screen event invites, galleries, admin portal, or AR route
  if (
    loc.pathname.startsWith("/invite") ||
    loc.pathname.startsWith("/photos") ||
    loc.pathname.startsWith("/admin") ||
    loc.pathname.startsWith("/ar")
  ) {
    return null;
  }

  const message = encodeURIComponent(
    "Hello KV Eventech! I'm planning an event and would love to inquire about your premium tech services."
  );
  const waLink = `https://wa.me/${BRAND.whatsapp}?text=${message}`;

  return (
    <a
      href={waLink}
      target="_blank"
      rel="noreferrer"
      className="fixed top-[52%] md:top-auto bottom-auto md:bottom-8 right-3 md:right-8 z-[99] flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-[#25D366] hover:bg-[#20ba5a] rounded-full text-white shadow-[0_8px_30px_rgba(0,0,0,0.4)] hover:shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-all duration-300 hover:scale-110 group cursor-pointer"
      aria-label="Contact us on WhatsApp"
    >
      {/* Tooltip */}
      <span className="absolute right-14 md:right-16 px-4 py-2 text-[10px] uppercase tracking-[0.2em] font-display bg-ink/95 border border-line text-parchment rounded-md opacity-0 scale-95 origin-right group-hover:opacity-100 group-hover:scale-100 transition-all duration-300 pointer-events-none whitespace-nowrap shadow-xl">
        Consult on WhatsApp
      </span>
      {/* Native WhatsApp SVG Icon */}
      <svg 
        viewBox="0 0 24 24" 
        fill="currentColor"
        className="w-[22px] h-[22px] md:w-[26px] md:h-[26px]"
      >
        <path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.96 9.96 0 0 0 1.333 4.982L2 22l5.202-1.364a9.92 9.92 0 0 0 4.808 1.236h.005c5.507 0 9.99-4.478 9.99-9.984C22.007 6.478 17.521 2 12.012 2zm6.368 14.171c-.279.785-1.615 1.5-2.223 1.58-.558.074-1.285.127-3.61-.83-2.978-1.222-4.894-4.25-5.043-4.45-.149-.199-1.21-1.61-1.21-3.072 0-1.462.768-2.181 1.042-2.474.274-.294.606-.367.808-.367.202 0 .404.002.58.01.18.008.423-.069.663.51.246.593.839 2.053.911 2.201.072.148.12.32.02.522-.099.201-.15.328-.299.502-.15.174-.314.388-.448.522-.149.149-.304.312-.13.61.173.298.769 1.267 1.65 2.052.176.155.334.302.483.43 1.135.978 2.036 1.24 2.378 1.393.342.153.538.107.728-.113.19-.22.827-.96 1.05-1.28.223-.32.446-.268.752-.155.305.113 1.942.915 2.274 1.08.332.164.553.243.633.38.08.137.08.795-.2 1.58z"/>
      </svg>
    </a>
  );
}
